import { render, staticRenderFns } from "./gaugeCar.vue?vue&type=template&id=35929c8c&"
import script from "./gaugeCar.vue?vue&type=script&lang=js&"
export * from "./gaugeCar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "gaugeCar.vue"
export default component.exports